import { createAction } from "@reduxjs/toolkit";
import { ISalsa } from "store/types";

import {
  BankCardResDto,
  CompanyResponseDto,
  ListUserCompaniesResDto,
  UpdateLastActiveRoleDto,
  UserProfileResponseDto,
  UserRewardPointsResDto,
} from "utils/swagger_react_query";

import {
  SET_BANK_CARDS,
  SET_COMPANIES_LIST,
  SET_COMPANY_DATA,
  SET_GLOBAL_LOADING,
  SET_ROUTER_USER_REQUEST_IN_PROGRESS,
  SET_SALSA,
  SET_USER_REWARD_POINTS,
  SET_WORKER_KYC_ONBOARDING_IN_PROGRESS,
  USER_METADATA_SET_METADATA,
  USER_METADATA_UPDATE_LAST_ACTIVE_ROLE,
} from "../constants/ActionTypes";

export const setUserMetaData = createAction<
  UserProfileResponseDto | null | undefined,
  typeof USER_METADATA_SET_METADATA
>(USER_METADATA_SET_METADATA);

export const updateUserMetaDataLastActiveRole = createAction<
  UpdateLastActiveRoleDto["role"],
  typeof USER_METADATA_UPDATE_LAST_ACTIVE_ROLE
>(USER_METADATA_UPDATE_LAST_ACTIVE_ROLE);

export const setCompanyData = createAction<CompanyResponseDto | null, typeof SET_COMPANY_DATA>(
  SET_COMPANY_DATA,
);

export const setCompaniesList = createAction<
  ListUserCompaniesResDto | null,
  typeof SET_COMPANIES_LIST
>(SET_COMPANIES_LIST);

export const setGlobalLoading = createAction<boolean, typeof SET_GLOBAL_LOADING>(
  SET_GLOBAL_LOADING,
);

export const setBankCards = createAction<BankCardResDto[] | null, typeof SET_BANK_CARDS>(
  SET_BANK_CARDS,
);

export const setSalsa = createAction<ISalsa | null, typeof SET_SALSA>(SET_SALSA);

export const setWorkerKycOnboardingInProgress = createAction<
  boolean,
  typeof SET_WORKER_KYC_ONBOARDING_IN_PROGRESS
>(SET_WORKER_KYC_ONBOARDING_IN_PROGRESS);

export const setRouterUserRequestInProgress = createAction<
  boolean,
  typeof SET_ROUTER_USER_REQUEST_IN_PROGRESS
>(SET_ROUTER_USER_REQUEST_IN_PROGRESS);

export const setUserRewardPoints = createAction<
  UserRewardPointsResDto | null,
  typeof SET_USER_REWARD_POINTS
>(SET_USER_REWARD_POINTS);
